export default __webpack_public_path__ + "static/media/generalInfo.da171bc3.png";